export const categories = {
  // Modal titles
  'categories.newCategory': 'New Category',
  'categories.editCategory': 'Edit Category',
  'categories.assignToCategories': 'Assign clients to categories',
  'categories.selectCategoryForClient': 'Select a category for each client',
  
  // Actions
  'categories.noCategory': 'No Category',
  
  // Messages
  'categories.saveSuccess': 'Category saved successfully',
  'categories.deleteSuccess': 'Category "{name}" deleted',
  'categories.saveFailed': 'Failed to save category',
  'categories.cannotDeleteDefault': 'Default categories cannot be deleted',
  'categories.deleteFailed': 'Failed to delete',
  'categories.confirmDelete': 'Delete category "{name}"?',
} as const;
